import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=e8a70d4e&scoped=true&"
import script from "./BookingDetail.vue?vue&type=script&lang=js&"
export * from "./BookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=e8a70d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a70d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8a70d4e')) {
      api.createRecord('e8a70d4e', component.options)
    } else {
      api.reload('e8a70d4e', component.options)
    }
    module.hot.accept("./BookingDetail.vue?vue&type=template&id=e8a70d4e&scoped=true&", function () {
      api.rerender('e8a70d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/BookingDetail.vue"
export default component.exports